import { isReactNative, isWeapp, isWeb } from 'yofobasement/utils/runtime';

export default {
  setString: (text, message) => {
    if (isReactNative()) {
      return require('react-native').Clipboard.setString(text);
    }
    if (isWeapp()) {
      wx.setClipboardData({
        data: text,
        success: () => {
          wx.showToast({
            title: message || '内容已复制',
            icon: 'none'
          });
        }
      });
    }
    if (isWeb()) {
      try {
        navigator.clipboard.writeText(text);
      } catch (e) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        document.body.appendChild(textarea);
        textarea.select();
        const success = document.execCommand('copy');
        document.body.removeChild(textarea);
      }
    }
  }
};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/Clipboard.js